import type { DdqSessionQuestion, ResponseTier } from '@/types/api.types';

export type SortOption = 'index' | 'confidence-desc' | 'confidence-asc' | 'tier';

const TIER_ORDER: Record<ResponseTier, number> = {
  Exact: 0,
  Suggested: 1,
  Generated: 2,
  NoMatch: 3,
};

export function sortQuestions(
  questions: DdqSessionQuestion[],
  sortBy: SortOption
): DdqSessionQuestion[] {
  const sorted = [...questions];

  switch (sortBy) {
    case 'index':
      return sorted.sort((a, b) => a.index - b.index);

    case 'confidence-desc':
      return sorted.sort((a, b) => b.confidence - a.confidence);

    case 'confidence-asc':
      return sorted.sort((a, b) => a.confidence - b.confidence);

    case 'tier':
      return sorted.sort((a, b) => {
        const tierDiff = TIER_ORDER[a.response_tier] - TIER_ORDER[b.response_tier];
        if (tierDiff !== 0) return tierDiff;
        return b.confidence - a.confidence;
      });

    default:
      return sorted;
  }
}
